<svg class="circular grit-circular" width="100%" height="100%">
  <circle cx="50%" cy="50%" class="path" [attr.r]="size / 2 - (strokeWidth / 2)" fill="none" [attr.stroke-width]="strokeWidth" stroke-miterlimit="10" />
</svg>
